import TagManager from 'react-gtm-module';
import { BrandGroupObject } from '../types/general';

// Call after initAuth: the FusionAuth callback URL has no brand until the original URL is restored.
export async function initTagManager(brandGroupUrl: string): Promise<void> {
  const brandId = new URLSearchParams(window.location.search).get('brand');
  const containerId = await getContainerId(brandId, brandGroupUrl);
  TagManager.initialize({ gtmId: containerId });
}

async function getContainerId(brandId: string | null, brandGroupUrl: string): Promise<string> {
  const containerId = sessionStorage.getItem('containerId');

  if (containerId) return containerId;
  if (!brandId) throw Error('Brand ID not provided and GTM ID not stored.');

  return fetchBrandGroups(brandGroupUrl)
    .then((brandGroupData) => {
      const brandGroup = brandGroupData.find((brandGroup) =>
        brandGroup.brands.some((brand) => brand.id === brandId)
      );
      if (!brandGroup) throw Error(`Could not find brand group for brand with ID: ${brandId}`);
      return brandGroup;
    })
    .then((brandGroup) => {
      const containerId = brandGroup.userTracking.containerId;
      sessionStorage.setItem('containerId', containerId);
      return containerId;
    });
}

function typedFetchToJson<TReturn>(url: string): Promise<TReturn> {
  return fetch(url).then((_) => _.json() as TReturn);
}

function fetchBrandGroups(brandGroupUrl: string): Promise<BrandGroupObject[]> {
  return typedFetchToJson<BrandGroupObject[]>(brandGroupUrl).catch((error) => {
    throw Error('Failed to retrieve brand group data:', error);
  });
}
